interface IMetaData {
    pageSlug: string;
    logoLink: string;
    pageDescription: string;
    pageTitle: string;
    cityName: string;
    host: string;
}

export const metaData = (props: IMetaData) => {
    const {
        logoLink = 'https://ct.sitisit.ru/_nuxt/img/logo-header.0585392.svg?v=1671786474246',
        pageDescription = '',
        pageTitle = '',
        pageSlug,
        cityName = 'Екатеринбурге',
        host,
    } = props;

    return [
        {
            hid: 'og:title',
            name: 'og:title',
            property: 'og:title',
            content: pageTitle || '',
        },
        {
            hid: 'og:site_name',
            name: 'og:site_name',
            property: 'og:site_name',
            content: `Central Trans`,
        },
        {
            hid: 'og:type',
            name: 'og:type',
            property: 'og:type',
            content: `website`,
        },
        {
            hid: 'og:description',
            name: 'og:description',
            property: 'og:description',
            content: pageDescription,
        },
        {
            hid: 'og:image',
            name: 'og:image',
            property: 'og:image',
            content: logoLink,
        },
        {
            hid: 'og:url',
            name: 'og:url',
            property: 'og:url',
            content: `https://${host}${pageSlug}`,
        },
    ];
};
